import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { UserEsercitazione } from 'src/app/model/esercitazione/useresercitazione';
import { UserEsercitazioneRisposta } from 'src/app/model/esercitazione/useresercitazionerisposta';
import { UserEsercitazioneDomanda } from 'src/app/model/esercitazione/useresercitazionedomanda';
import { EsercitazioneService } from 'src/app/service/esercitazione.service';
import { first } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/app/model/constants';

@Component({
  selector: 'app-esercitazione-svolgimento',
  templateUrl: './esercitazione-svolgimento.component.html',
  styleUrls: ['./esercitazione-svolgimento.component.css']
})
export class EsercitazioneSvolgimentoComponent implements OnInit, OnDestroy {

    @Input() esercitazione: UserEsercitazione;
    @Input() isTfaSimulator: boolean = false;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onValutaEsercitazioneClick: EventEmitter<UserEsercitazione> = new EventEmitter<UserEsercitazione>();
    currentQuestion = 0;
    domandaImage: any;
    tfaExplanations: any = {};
    
    // Timer properties
    timeLeft: number = Constants.TFA_SIMULATOR_TIMER_SECONDS; 
    timerInterval: any;
    alertTime: number = Constants.TFA_SIMULATOR_TIMER_ALERT_SECONDS;

    private readonly imageType: string = 'data:image/JPG;base64,';

    constructor(
        private sanitizer: DomSanitizer,
        private esercitazioneSrv: EsercitazioneService,
        private http: HttpClient
    ) { }

    ngOnInit() {
        this.getDomandaImageJson();
        if (this.isTfaSimulator) {
            this.http.get('assets/tfa-data.json').subscribe(data => {
                this.tfaExplanations = data;
            });
            this.startTimer();
        }
    }

    ngOnDestroy() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }

    startTimer() {
        this.timerInterval = setInterval(() => {
            if (this.timeLeft > 0) {
                this.timeLeft--;
            } else {
                clearInterval(this.timerInterval);
                this.valutaEsercitazione(); // Tempo scaduto, auto-valutazione
            }
        }, 1000);
    }

    get formattedTime(): string {
        const h = Math.floor(this.timeLeft / 3600);
        const m = Math.floor((this.timeLeft % 3600) / 60);
        const s = Math.floor(this.timeLeft % 60);
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }

    // TODO inserire i dati delle spiegazioni tfa sostegno nel db al posto di json statico
    valutaEsercitazione() {
    
        // faccio una copia per non sporcare il payload verso il backend Java
        const cleanEsercitazione = JSON.parse(JSON.stringify(this.esercitazione));
        if (cleanEsercitazione && cleanEsercitazione.domande) {
            cleanEsercitazione.domande.forEach((d: any) => {
                delete d.showExplanation;
                delete d.explanationText;
                if (d.risposte) {
                    d.risposte.forEach((r: any) => {
                        delete r.isCorrect;
                        delete r.isWrong;
                    });
                }
            });
        }

        this.onValutaEsercitazioneClick.emit(cleanEsercitazione);
    }

    prevQuestion() {
        if (this.currentQuestion === 0) {
            this.currentQuestion = this.esercitazione.domande.length - 1;
        } else {
            this.currentQuestion = this.currentQuestion - 1;
        }

        this.getDomandaImageJson();
    }

    nextQuestion() {
        if (this.currentQuestion === this.esercitazione.domande.length - 1) {
            this.currentQuestion = 0;
        } else {
            this.currentQuestion = this.currentQuestion + 1;
        }

        this.getDomandaImageJson();
    }

    getDomandaImage() {
        this.esercitazioneSrv.downloadEsercitazioneDomandaImage(
            this.esercitazione.domande[this.currentQuestion].id,
            this.esercitazione.domande[this.currentQuestion].immagineAssociata)
        .pipe(first())
        .subscribe(
            data => {
                const reader = new FileReader();
                reader.addEventListener('load', () => {
                    this.domandaImage = reader.result;
                }, false);

                if (data) {
                    reader.readAsDataURL(data);
                }
            },
            error => {
                return;
            }
        );
    }

    getDomandaImageJson() {
        if (this.esercitazione.domande[this.currentQuestion].immagineAssociata == null) {
            this.domandaImage = null;
        } else {
            this.esercitazioneSrv.downloadEsercitazioneDomandaImageJson(
            this.esercitazione.domande[this.currentQuestion].immagineAssociata)
            .pipe(first())
            .subscribe(
                data => {
                    this.domandaImage = this.sanitizer.bypassSecurityTrustUrl(this.imageType + data.result);
                },
                error => {
                    return;
                }
            );
        }
    }

    onRispostaChange(domanda: any, selectedRisposta: any) {
        domanda.risposte.forEach(risposta => {
            if (risposta === selectedRisposta) {
                risposta.flagRispostaData = selectedRisposta.flagRispostaData;
            } else {
                risposta.flagRispostaData = false;
            }
        });

        if (this.isTfaSimulator && selectedRisposta.flagRispostaData) {
            // Cerco la domanda tfa sostegno nel file JSON statico
            const expData = this.tfaExplanations[domanda.domanda];
            if (expData) {
                domanda.showExplanation = true;
                domanda.explanationText = expData.explanation;
                
                domanda.risposte.forEach(r => {
                    // Controllo se il testo della risposta corrisponde a quella nel JSON statico
                    r.isCorrect = (r.risposta.trim() === expData.correct.trim());
                    // Segna come sbagliata solo se è quella selezionata e non è corretta
                    r.isWrong = (r === selectedRisposta && !r.isCorrect);
                });
            }
        } else {
            domanda.showExplanation = false;
        }
    }

}
